import React, { useState, useContext, useEffect } from 'react';
import request from 'services/http';
import { Button, Icon, Divider, Modal, Header, Grid, Container, Form, Comment, Popup, } from 'semantic-ui-react';
import Table from 'components/Table';
import PageLoader from 'components/PageLoader';
import { DateTime } from 'luxon';
import { download } from '@rededompedro/utils';
import { GlobalContext } from 'globalContext';
import { toast } from 'react-toastify';
import { numFormat } from '@rededompedro/utils';
import './style.css';

export default function Saldos({ history, empresas, dadosSaldos, setDadosSaldos }) {
    const [selectRow, setSelectedRow] = useState([]);
    const [isFetching] = useState(dadosSaldos ? false : true);
    const params = Object.fromEntries(
        new URLSearchParams(history.location.search.replace('?=', '')).entries(),
    );
    const [openModalJustification, setOpenModalJustification] = useState(false);
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [{ user }] = useContext(GlobalContext);
    const emp = empresas.find((it) => it && it.codDpnet === params.empresa);
    const [deleteJustificativaId, setDeleteJustificativaId] = useState();
    const [note, setNote] = useState('');
    const [justificativaDiferenca, setJustificativaDiferenca] = useState(0);
    const [justificativasFormat, setJustificativasFormat] = useState();
    const [parcelasDescontadas, setParcelasDescontadas] = useState();
    const [comentarios, setComentarios] = useState();
    const [idComentario, setIdComentario] = useState();
    const [disableButton, setDisableButtonObs] = useState(false)
    const [loadingButton, setLoadingButton] = useState(false)

    var arrayJustifications = [];
    var arrayComments = [];
    var blur, growDiv, wrapper;

    let managerUser = (user.cod === 8383 || user.codigo === 8383) || user.setor === 18


    useEffect(() => {
        request({
            url: '/controladoria/apuracao-caixa/saldo',
            method: 'GET',
            params,
        })
            .toPromise()
            .then(({ response }) => {
                setDadosSaldos({
                    saldos: response.saldos,
                    saldosUnicos: response.resultsUnicos,
                })
                if (response.resultsUnicos) {
                    response.resultsUnicos.forEach((item) => {
                        if (!arrayJustifications.some((el) => el['id'] === item.id)) {
                            arrayJustifications.push({
                                id: item.id,
                                created_by: item.nome_central,
                                id_funcionario: item.nome_funcionario
                                    ?.toLowerCase()
                                    .replace(/(?:^|\s)\S/g, (a) => {
                                        return a.toUpperCase();
                                    }),
                                turno: item.turno,
                                descricao: item.descricao,
                                created_at: item.just_created_at,
                                valor: item.valor,
                                diferenca: item.diferenca,
                                observacao: item.observacao,
                                data: item.data,
                                cod_emp: item.cod_emp,
                                id_data: item.id_data,
                                parcela: item.parcela,
                                anexo: item.anexo,
                                seq: item.seq
                            });
                        }
                        if (item.obs) {
                            arrayComments.push({
                                id: item.id,
                                comments: item.obs,
                                created_at: item.obs_created_at,
                                created_by: item.nome_comments,
                            });
                        }
                    });
                    setJustificativasFormat(arrayJustifications);
                    var CommentsFormat = [
                        ...arrayJustifications.map((item) => {
                            return {
                                observacao: item.observacao,
                                id_apuracao: item.id,
                                header: true,
                                created_at: item.created_at,
                                created_by: item.created_by,
                            };
                        }),
                        ...arrayComments.map((item) => {
                            return {
                                observacao: item.comments,
                                id_apuracao: item.id,
                                header: false,
                                created_at: item.created_at,
                                created_by: item.created_by,
                            };
                        }),
                    ]; // Array com os 2 arrays, de justificativas e observações
                    setComentarios(CommentsFormat);
                }
            })
            .catch((err) => {
                toast.error('Falha ao carregar dados!');
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const goBack = () => {
        history.goBack();
    }; // Volta para a página principal

    const configTable = {
        columns: [
            { field: 'seq', text: 'Sequência', sort: true },
            { field: 'data', text: 'Data do Caixa', sort: true },
            { field: 'turno', text: 'Turno', sort: false },
            { field: 'diferenca', text: 'Diferença', sort: true },
            { field: 'detalhes', text: 'Visualizar Justificativa(s)', sort: false },
        ],
        data: dadosSaldos.saldos
            ? dadosSaldos.saldos.map((it) => ({
                detalhes: (
                    <Button
                        onClick={() => SelectSave(it)}
                        icon
                        size="mini"
                        color="instagram"
                        labelPosition="right"
                        content={
                            <>
                                <Icon name="arrow right" /> Detalhes
                            </>
                        }
                    />
                ),
                data: it.data,
                turno: it.turno,
                diferenca: 'R$ ' + numFormat(it.diferenca),
                seq: it.seq,
            }))
            : [],
        filter: true,
        exportData: true,
    }; // Popula a tabela com dados


    const SelectSave = async (it) => {
        var filtroJustificativaDiferenca = justificativasFormat.filter(
            (j) => j.seq === it.seq,
        );
        setSelectedRow(it);
        setJustificativaDiferenca(filtroJustificativaDiferenca);

        if (managerUser) {
            let idJustificativa = '';
            for (const filtro of filtroJustificativaDiferenca) {
                idJustificativa = idJustificativa + filtro.id + ',';
            }
            let payload = {
                id: `(${idJustificativa.substring(0, idJustificativa.length - 1)})`,
            };


            await request({
                url: '/controladoria/descontos/delete',
                method: 'POST',
                body: payload,
            })
                .toPromise()
                .then(({ response }) => {
                    if (response) {
                        setParcelasDescontadas(response.descontos);
                        setOpenModalJustification(true);
                    } else {
                        return toast.error('Houve um problema interno.', {
                            toastId: 'vereficar-desconto-error',
                        });
                    }
                })
                .catch((err) => {
                    return toast.error('Houve um problema interno.', {
                        toastId: 'vereficar-desconto-error',
                    });
                });
        } else {
            setOpenModalJustification(true);
        }

    }; /* Função que recebe os dados da diferença selecionada, cria uma variável que filtra o array principal, trazendo de volta 
    apenas as justificativas referentes a diferença selecionada  */

    const myStyle = {
        transition: 'height .6s',
        height: '59px',
        overflow: 'hidden',
        position: 'relative',
    };

    const handleButtonBlurComments = (e, id_justificativa) => {
        blur = document.getElementById('blur' + id_justificativa);
        growDiv = document.getElementById(id_justificativa);
        if (growDiv.clientHeight > 110) {
            blur.classList.add('showBlur');
            e.target.innerHTML = `Ver mais`;

            growDiv.style.height = '59px';
        } else {
            wrapper = document.getElementById('idJustificativa' + id_justificativa);
            growDiv.style.height = wrapper.clientHeight + 'px';
            e.target.innerText = 'Ver menos';
            blur.classList.remove('showBlur');
        }
    }; // Adiciona um blur nas observações que ultrapassam 59px

    let arrayComentariosFrontEnd = [];
    const saveNote = async (obs, id, date) => {
        if (obs.length < 5) {
            return toast.error('Inclua uma observação com mais de 5 caracteres!', {
                toastId: id + 'save-obs-error',
            });
        }

        const payload = {
            id: id,
            obs: obs,
        };


        setDisableButtonObs(true)
        await request({
            url: `/controladoria/observacao`,
            method: 'POST',
            body: payload,
        })
            .toPromise()
            .then(({ response }) => {
                if (response) {
                    arrayComentariosFrontEnd.push(...comentarios, {
                        observacao: obs,
                        id_apuracao: id,
                        header: false,
                        created_at: date,
                        created_by: user.nome,
                    });

                    setComentarios(arrayComentariosFrontEnd);
                    toast.success('Observação incluída com sucesso!', {
                        toastId: id + 'save-note-success',
                    });
                    setNote('');
                } else {
                    toast.error('Houve um problema ao salvar sua observação!', {
                        toastId: id + 'save-error',
                    });
                }

            })
            .catch((err) => {
                toast.error('Insira uma observação!', {
                    toastId: id + 'save-note-error',
                });
            });
        setDisableButtonObs(false)
        blur = document.getElementById('blur' + id);
        if (blur !== null) {
            blur.firstElementChild.innerHTML = 'Ver Menos';
        }
        growDiv = document.getElementById(id);
        wrapper = document.getElementById('idJustificativa' + id);
        growDiv.style.height = wrapper.clientHeight + 'px';
    }; // Insere no banco de dados as observações relacionadas a cada justificativa
    useEffect(() => {
        if (justificativaDiferenca.length === 0) {
            setOpenModalJustification(false);
        }
    }, [
        justificativaDiferenca,
    ]); /* Executa essa parte do código cada vez que o estado justificativas é atualizado, para que quando
    o tamanho o array for zero, ele feche o modal */

    const SelectSaveDelete = async (id) => {
        setDeleteJustificativaId(id);
        setOpenModalDelete(true);
    };
    const formatValue = (value) => {
        let format = Math.round((value * 10) / 10)
            .toString()
            .replace(/\D/g, '')
            .replace(/(\d{1,2})$/, ',$1')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        return format;
    }; /*Função que formata os valores recebidos para numeros com pontos , exemplo 125014 ->  1.250.14 */

    const deleteJustification = async (id) => {
        const justificativaDados = dadosSaldos.saldosUnicos.filter((d) => d.id === id)
        const payload = justificativaDados[0];


        setLoadingButton(true)
        await request({
            url: `/controladoria/delete/`,
            method: 'POST',
            body: payload,
        })
            .toPromise()
            .then(({ response }) => {
                if (response.status === 'ok') {
                    growDiv = document.getElementById(id);
                    growDiv.style.height = '59px';
                    toast.success('Justificativa excluida com sucesso!', {
                        toastId: id + 'delete-success',
                    });
                    setJustificativasFormat(
                        justificativasFormat.filter((justificativa) => justificativa.id !== id)
                    )
                    setDadosSaldos({
                        ...dadosSaldos,
                        saldosUnicos: dadosSaldos.saldosUnicos.filter((saldos) => saldos.id !== id),
                    });
                    setJustificativaDiferenca(justificativaDiferenca.filter((justificativa) => justificativa.id !== id));
                    if (justificativaDiferenca.filter((justificativa) => justificativa.id !== id).length === 0) {
                        setDadosSaldos({
                            ...dadosSaldos,
                            saldos: dadosSaldos.saldos.filter((justificativa) => justificativa.seq !== justificativaDados[0].seq),
                        });
                    }
                } else if (response.status === 'parcelaPg') {
                    toast.error(`Há ${response.parcela} parcela(s) enviadas para desconto!`, {
                        toastId: id + 'delete-errorPg',
                    });
                } else {
                    toast.error('Falha ao excluir Justificativa!', {
                        toastId: id + 'delete-error',
                    });
                }
            })
            .catch((err) => {
                toast.error('Falha ao excluir Justificativa!', {
                    toastId: id + 'delete-error',
                });
            });
        setLoadingButton(false)
        setOpenModalDelete(false);
    }; /*Função que deleta as justificativas do banco de dados e atualiza os states para que seja refletido na tela */

    const downloadFile = (id, anexo) => {
        const payload = {
            download: anexo,
        };
        request({
            url: `/controladoria/download`,
            method: 'GET',
            responseType: 'blob',
            params: payload,
        })
            .toPromise()
            .then((data) => {
                download(data.response, `justificativa_${id}_${emp.codDpnet}.pdf`);
                toast.success('Download realizado com sucesso!', {
                    toastId: id + 'download-success',
                });
            })
            .catch((err) => {
                toast.error('Falha ao realizar Download do arquivo!', {
                    toastId: id + 'download-error',
                });
            });
    }; /*Função para Download de pdfs*/

    const style = {
        color: 'black',
        backgroundColor: 'white',
        boxShadow: 'unset',
    };

    const inline = {
        textDecoration: 'none',
        display: 'inline',
    };
    const blockNoteCharacters = (ev) => {
        if (ev.target.value.length < 2 && (ev.key === ' ' || ev.key === 'Enter')) {
            ev.preventDefault();
        }
    };
    const getNote = (event, id) => {
        setIdComentario(id);
        setNote(event.target.value);
    }; /*Função que recebe o que foi digitado no textArea das observações e o id da justificativa relacionada, que serão usados posteriormente
    para fazer validações */

    return (
        <PageLoader active={isFetching}>
            <div className="row mt-2">
                <div className="col-12 col-md d-flex align-items-end">
                    <p className="mb-0">
                        <strong>Empresa: </strong> {emp ? emp.nomeEmpresa : ''} -{' '}
                        {params.dataIni + ' Até ' + params.dataFim}
                    </p>
                </div>
                <div className="col-12 col-md-2 d-print-none">
                    <Button icon size="tiny" className="btn-red" floated="right" onClick={goBack}>
                        <Icon name="arrow left" /> Voltar
                    </Button>
                </div>
            </div>
            <Divider className="mt-2 custom-divider darken" fitted />
            <Table celled id="table-saldos" singleLine sortable selectable {...configTable} />
            <Modal
                open={openModalJustification}
                closeIcon
                onClose={() => setOpenModalJustification(!openModalJustification)}
            >
                <Modal.Header>
                    <Grid>
                        <Grid.Column floated="left" width={11}>
                            <Header as="h3" floated="left">
                                Diferença R$ {numFormat(selectRow.diferenca)}
                                <Header.Subheader
                                    style={{
                                        backgroundColor: '#1a4b84',
                                        color: 'white',
                                    }}
                                >
                                    {emp ? emp.nomeEmpresa : ''}
                                </Header.Subheader>
                            </Header>
                        </Grid.Column>
                        <Grid.Column floated="right" width={5}>
                            <Header as="h4" floated="right">
                                Data do caixa - {selectRow.data}
                            </Header>
                        </Grid.Column>
                    </Grid>
                </Modal.Header>

                {justificativaDiferenca.length &&
                    justificativaDiferenca.map((justificativa, index) => (
                        <div key={index}>
                            <Modal.Content>
                                <Container className="mt-4" text>
                                    <Grid>
                                        <Grid.Column floated="left" width={10}>
                                            <Header style={style} as="h5">
                                                ID Justificativa
                                                <Header.Subheader style={style}>
                                                    {justificativa.id}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                        <Grid.Column floated="right" width={6}>
                                            <Header style={style} as="h5">
                                                Registrado por:
                                                <Header.Subheader style={style}>
                                                    {justificativa.created_by}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                    </Grid>
                                    <Grid>
                                        <Grid.Column floated="left" width={10}>
                                            <Header style={style} as="h5">
                                                Colaborador(a)
                                                <Header.Subheader style={style}>
                                                    {justificativa.id_funcionario
                                                        ? justificativa.id_funcionario
                                                        : 'Sem colaborador(a) Vinculádo.'}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                        <Grid.Column floated="right" width={6}>
                                            <Header style={style} as="h5">
                                                Turno
                                                <Header.Subheader style={style}>
                                                    {justificativa.turno}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                    </Grid>
                                    <Grid>
                                        <Grid.Column floated="left" width={10}>
                                            <Header style={style} as="h5">
                                                Tipo da Justificativa
                                                <Header.Subheader style={style}>
                                                    {justificativa.descricao}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                        <Grid.Column floated="right" width={6}>
                                            <Header style={style} as="h5">
                                                Data do Registro
                                                <Header.Subheader style={style}>
                                                    {DateTime.fromFormat(
                                                        String(justificativa.created_at),
                                                        'yyyy-MM-dd HH:mm:ss',
                                                    ).toFormat('dd/MM/yyyy HH:mm:ss')}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                    </Grid>
                                    <Grid>
                                        <Grid.Column floated="left" width={10}>
                                            <Header style={style} as="h5">
                                                Diferença de Caixa
                                                <Header.Subheader style={style}>
                                                    R$ {numFormat(justificativa.diferenca)}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                        <Grid.Column floated="right" width={6}>
                                            <Header style={style} as="h5">
                                                Valor
                                                <Header.Subheader style={style}>
                                                    {justificativa.parcela} x R${' '}
                                                    {Math.floor(
                                                        (justificativa.valor * 100) /
                                                        justificativa.parcela,
                                                    ) < 100
                                                        ? '0'
                                                        : ''}
                                                    {formatValue(
                                                        Math.floor(
                                                            (justificativa.valor * 100) /
                                                            justificativa.parcela,
                                                        ),
                                                    )}{' '}
                                                    = R${' '}
                                                    {formatValue(
                                                        Math.floor(
                                                            (justificativa.valor * 100) /
                                                            justificativa.parcela,
                                                        ) * justificativa.parcela,
                                                    )}
                                                </Header.Subheader>
                                            </Header>
                                        </Grid.Column>
                                    </Grid>
                                    <Grid>
                                        <Grid.Column floated="left">
                                            <h5 style={{ textAlign: 'center' }}>Observações</h5>
                                            <Comment.Group
                                                className="mt-4 style "
                                                style={
                                                    comentarios.filter(
                                                        (result) =>
                                                            result.id_apuracao ===
                                                            justificativa.id &&
                                                            result.header === false,
                                                    ).length > 0
                                                        ? myStyle
                                                        : null
                                                }
                                                id={justificativa.id}
                                            >
                                                <div id={'idJustificativa' + justificativa.id}>
                                                    {comentarios.map((item, index) => {
                                                        if (justificativa.id === item.id_apuracao) {
                                                            return (
                                                                <Comment key={index}>
                                                                    <Comment.Content>
                                                                        <>
                                                                            <Comment.Author
                                                                                style={inline}
                                                                            >
                                                                                {item.created_by}
                                                                            </Comment.Author>
                                                                            <Comment.Metadata>
                                                                                <div>
                                                                                    {' '}
                                                                                    {DateTime.fromFormat(
                                                                                        String(
                                                                                            item.created_at,
                                                                                        ),
                                                                                        'yyyy-MM-dd HH:mm:ss',
                                                                                    ).toFormat(
                                                                                        'dd/MM/yyyy HH:mm',
                                                                                    )}
                                                                                </div>
                                                                            </Comment.Metadata>
                                                                            <Comment.Text>
                                                                                {item.observacao}
                                                                            </Comment.Text>
                                                                        </>
                                                                    </Comment.Content>

                                                                    <Divider />
                                                                </Comment>
                                                            );
                                                        }
                                                        return null
                                                    }
                                                    )}
                                                </div>
                                            </Comment.Group>
                                            {comentarios.filter(
                                                (item) =>
                                                    item.id_apuracao === justificativa.id &&
                                                    item.header === false,
                                            ).length > 0 ? (
                                                <div
                                                    className="showBlur"
                                                    id={'blur' + justificativa.id}
                                                >
                                                    <Button
                                                        size="mini"
                                                        onClick={(e) =>
                                                            handleButtonBlurComments(
                                                                e,
                                                                justificativa.id,
                                                            )
                                                        }
                                                        content="Ver Mais"
                                                    />
                                                </div>
                                            ) : (
                                                ''
                                            )}

                                            <Form className="m-0 mt-3">
                                                <Form.TextArea
                                                    onChange={(e) => {
                                                        getNote(e, justificativa.id);
                                                    }}
                                                    onKeyDown={blockNoteCharacters}
                                                    value={justificativa.id === idComentario ? note : ''}
                                                    style={{
                                                        height: '70px',
                                                        width: '100%',
                                                    }}
                                                />

                                                <Button
                                                    content="Adicionar observação"
                                                    labelPosition="right"
                                                    icon="edit"
                                                    primary
                                                    size="mini"
                                                    disabled={disableButton}
                                                    onClick={() => {
                                                        if (justificativa.id === idComentario) {
                                                            saveNote(
                                                                note,
                                                                justificativa.id,
                                                                DateTime.local().toFormat(
                                                                    'yyyy-MM-dd HH:mm:ss',
                                                                ),
                                                            );
                                                        } else {
                                                            toast.error(
                                                                'Insira uma observação Id -' +
                                                                justificativa.id,
                                                                {
                                                                    toastId: justificativa.id,
                                                                },
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Form>
                                        </Grid.Column>
                                    </Grid>
                                    <Grid>
                                        <Grid.Column floated="left" width={11}>
                                            <Header style={style} as="h5">
                                                Deletar Justificativa
                                            </Header>
                                            {managerUser &&
                                                parcelasDescontadas?.filter(
                                                    (d) => d.id_justificativa === justificativa.id,
                                                ).length === 0 ? (
                                                <Button
                                                    onClick={() =>
                                                        SelectSaveDelete(justificativa.id)
                                                    }
                                                    icon
                                                    size="mini"
                                                    color="red"
                                                    labelPosition="right"
                                                    content={
                                                        <>
                                                            <Icon name="close" /> Deletar{' '}
                                                        </>
                                                    }
                                                />
                                            ) : (
                                                <Popup
                                                    trigger={
                                                        <Button
                                                            disabled={
                                                                managerUser
                                                                    ? false
                                                                    : true
                                                            }
                                                            style={{ cursor: 'default' }}
                                                            icon
                                                            size="mini"
                                                            color="grey"
                                                            labelPosition="right"
                                                            content={
                                                                <>
                                                                    <Icon name="close" /> Deletar{' '}
                                                                </>
                                                            }
                                                        />
                                                    }
                                                    style={{ borderRadius: 0, opacity: 0.7 }}
                                                    inverted
                                                    content={`Justificativa ${justificativa.id
                                                        } não pode ser excluída! ${parcelasDescontadas?.filter(
                                                            (d) =>
                                                                d.id_justificativa ===
                                                                justificativa.id,
                                                        ).length
                                                        } parcela(s) enviadas para desconto!.`}
                                                    basic
                                                    position="right center"
                                                    size="mini"
                                                />
                                            )}
                                        </Grid.Column>
                                        <Grid.Column floated="right" width={5}>
                                            <Header style={style} as="h5">
                                                Download anexo
                                            </Header>
                                            <Button
                                                onClick={() =>
                                                    downloadFile(
                                                        justificativa.id,
                                                        justificativa.anexo,
                                                    )
                                                }
                                                icon
                                                size="mini"
                                                color="green"
                                                labelPosition="right"
                                                content={
                                                    <>
                                                        <Icon name="file pdf" /> Download
                                                    </>
                                                }
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Container>
                            </Modal.Content>

                            {justificativa.length - 1 === index ? '' : <hr className="mt-4" />}
                        </div>
                    ))}
                <Modal.Actions className="mt-4">
                    <Button basic color="black" onClick={() => setOpenModalJustification(false)}>
                        Fechar
                    </Button>
                </Modal.Actions>
            </Modal>

            <Modal size="mini" open={openModalDelete}>
                <Modal.Header
                    style={{
                        backgroundColor: 'white',
                        color: 'black',
                    }}
                >
                    Apagar Justificativa {deleteJustificativaId}
                </Modal.Header>
                <Modal.Content>Você realmente deseja excluir essa Justificativa?'</Modal.Content>
                <Modal.Actions>
                    <div>
                        <Button onClick={() => setOpenModalDelete(false)} negative>
                            Não
                        </Button>
                        <Button
                            loading={loadingButton}
                            disabled={loadingButton}
                            positive
                            onClick={() =>
                                deleteJustification(
                                    deleteJustificativaId
                                )
                            }
                        >
                            Sim, apagar
                        </Button>
                    </div>
                </Modal.Actions>
            </Modal>
        </PageLoader>
    );
}
